import React from 'react'
import { FormikProps } from 'formik'
import { PackType, GroupedEditionsType, IPackInput } from '../../types/pack'
import {
  getPackErrors,
  getGenericEditionsErrors,
  getGenericPackError,
} from '../../services/packForm'
import { getTab } from '../../services/views'
import { isArchive } from '../../services/editionsHelpers'
import { Sidebar } from '../Sidebar'
import { StyledNavLink } from '../StyledNavLink'
import { DeletedFileWarningIcon } from '../DeletedFileWarningIcon'
import { FileItem } from './FileItem'
import { FileTreeIcon, FileTreeTypes } from './FileTreeIcon'
import { FileTreeCheck } from './FileTreeCheck'
import { Archive } from './Archive'
import { StyledOverallPackTitle } from './styled'

interface IRouteParams {
  groupId: string
  packId: string
}

interface IGraphicSidebar {
  match: { params: IRouteParams }
  location: Location
  pack: PackType
  groupedEditions: GroupedEditionsType
  editionId: string
  isDeletedFilePresentInEditions: boolean
  formikProps: FormikProps<IPackInput>
}

export const GraphicSidebar = ({
  match: {
    params: { groupId, packId },
  },
  location,
  pack,
  groupedEditions,
  editionId,
  isDeletedFilePresentInEditions,
  formikProps,
}: IGraphicSidebar) => {
  const errors = getPackErrors(formikProps.errors)
  const genericEditionsErrors = getGenericEditionsErrors(formikProps.errors)
  return (
    pack && (
      <Sidebar
        title="Files in this pack"
        warning={
          isDeletedFilePresentInEditions
            ? 'The pack contains an infected file that has been deleted by the anti virus'
            : ''
        }
      >
        <StyledNavLink
          to={`/group/${groupId}/pack/${packId}?edition=overall-pack&tab=${getTab(
            location
          )}`}
          isActive={() => packId === pack.id && editionId === 'overall-pack'}
          theme="green"
          style={{ display: 'flex' }}
        >
          <FileTreeIcon mediaType={FileTreeTypes.archive} />
          <StyledOverallPackTitle>
            <span>Overall pack</span>
            {isDeletedFilePresentInEditions && <DeletedFileWarningIcon />}
          </StyledOverallPackTitle>
          <FileTreeCheck
            status={
              !!pack.publishing && !!pack.publishing.publishing
                ? 'publishing'
                : errors.overallPack || errors.editions.length !== 0
                ? 'error'
                : 'done'
            }
            all
            genericError={getGenericPackError(formikProps.errors)}
          />
        </StyledNavLink>
        {groupedEditions.map((edition) =>
          isArchive(edition) ? (
            <Archive
              id={`archive-${edition.archiveId}`}
              key={edition.archiveId}
              archiveName={edition.archiveName}
              location={location}
              groupId={groupId}
              packId={packId}
              editionId={editionId}
              defaultLanguage={pack.language ?? ''}
              errors={errors}
              genericEditionsErrors={genericEditionsErrors}
            >
              {edition.editions}
            </Archive>
          ) : (
            <FileItem
              edition={edition}
              id={`edition-${edition.id}`}
              key={edition.id}
              href={`/group/${groupId}/pack/${packId}?edition=${
                edition.id
              }&tab=${getTab(location)}`}
              isActive={() => edition.id === editionId}
              defaultLanguage={pack.language ?? ''}
              error={
                errors.editions.includes(edition.editionIndex) &&
                genericEditionsErrors[edition.editionIndex]
              }
            />
          )
        )}
      </Sidebar>
    )
  )
}
